import cn from 'classnames';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { Profile, ProfileListItem } from '../../../containers/profileListItem';
import ProfilePicture from '../../UserProfile/ProfilePicture';
import DocumentCount from './DocumentCount';
import styles from './styles.module.css';

interface BulkProfileImagesProps {
  onOpenProfilePicturePicker: (profile: Profile) => void;
  onProfilePictureUpload: ({ files }: any) => void;
  onDeleteProfilePicture: () => void;
  updatedImage: string;
  allowEdit: boolean;
  item: Profile;
  isParentDragActive: boolean;
  onOpenDocumentUpload?: (profileId: string, onOpenDocumentPicker: (options?: { confidential?: boolean }) => void) => void;
  allowDocumentUpload?: boolean;
  onOpenDocumentPicker?: (options?: { confidential?: boolean }) => void;
  profile?: Profile;
}

const BulkProfileImages = ({
  allowEdit,
  item,
  updatedImage,
  onDeleteProfilePicture,
  onOpenProfilePicturePicker,
  onProfilePictureUpload,
  isParentDragActive,
  onOpenDocumentUpload,
  allowDocumentUpload,
  onOpenDocumentPicker,
  profile: profileFromHoc,
}: BulkProfileImagesProps) => {
  // The HOC provides profile prop, but InfiniteGalleryView passes item prop
  // UploadProfilePictureHoc handles this by extracting profile from item if needed
  const profile = profileFromHoc || item;
  const { t } = useTranslation();
  const { getRootProps, isDragActive } = useDropzone({
    noClick: true,
    onDrop: (files) => {
      if (allowEdit) {
        onProfilePictureUpload({ files });
      }
    },
  });

  return (
    <div
      {...getRootProps({
        className: `d-flex w-100 profile-${profile.id}-dropzone`,
      })}
    >
      <ProfileListItem
        profile={profile}
        fields={[]}
        isVerticallyStacked
        className={cn(styles.profileListItem, {
          [styles.dropzoneActive]: isDragActive && allowEdit,
        })}
      >
        <div className={styles.profileImageWrapper}>
          <ProfilePicture
            image={updatedImage}
            allowEdit={allowEdit}
            onEdit={onOpenProfilePicturePicker}
            isDragActive={isParentDragActive}
            dropzoneClassName={styles.dropzone}
            onDelete={onDeleteProfilePicture}
          />
          {allowDocumentUpload && onOpenDocumentUpload && onOpenDocumentPicker && (
            <div className={styles.uploadDocumentContainer}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onOpenDocumentUpload(profile.id, onOpenDocumentPicker);
                }}
                className={styles.uploadDocumentLink}
              >
                {t('Upload document')} <DocumentCount profileId={profile.id} />
              </a>
            </div>
          )}
        </div>
      </ProfileListItem>
    </div>
  );
};

export default BulkProfileImages;
